/* Imports */
// Library
import { select } from 'd3'
// Local

import './style.scss';
import PoleSlide from '../PolarSlide/PolarSlide';
import Toggle from '../Toggle/Toggle';
import { CLASSES as C, CONFIG, TOGGLE_VALS } from '../../globals/constants';
import { colors } from '../../globals/helpers';



export default class PolarizationChart {
  constructor(data) {
    this.data = data
    this.selection = select('#pole-chart')
    this.slides = [] // store Card instances as member variables to be accessed from App.js

    this.toggleVals = TOGGLE_VALS
    this.currentColumn = TOGGLE_VALS[0].text
  }

  /* Things that only happen once */
  init() {

    this.chartLabels = this.selection
      .append('div')
      .attr('class', `${C.POLAR}-${C.LABEL}`)

    // setup toggle
    this.toggleWrapper = this.selection
      .append('div')
      .attr('class', `${C.TOGGLE}-${C.WRAPPER}`)

    this.toggle = new Toggle(this.toggleWrapper,
      this.toggleVals,
      TOGGLE_VALS[0].val,
      this.handleToggle);

    // legend
    this.chartLabels
      .append("div")
      .attr("class", `${C.LEGEND}`)
      .selectAll(`.${C.LEGEND}-${C.ITEM}`)
      .data(CONFIG.COLOR_DOMAIN)
      .join("div")
      .attr("class", `${C.LEGEND}-${C.ITEM}`)
      .call(legendItem => legendItem
        .append("div")
        .attr("class", `${C.LINE}`)
        .style("background-color", d => colors(d)))
      .call(legendItem => legendItem
        .append("div")
        .attr("class", `${C.PARTY}`)
        .html(d => d))

    this.selection
      .selectAll(`.${C.PoleSlide}-${C.SLIDE}-${C.WRAPPER}`)
      .data(this.data)
      .join('div')
      .attr('class', `${C.PoleSlide}-${C.SLIDE}-${C.WRAPPER}`)
      .each(({ key, data }, i, s) => { this.slides.push(new PoleSlide(select(s[i]), data, key)) })
  }

  /* Toggle Handler */
  // note - using arrow function's lexical binding to bind "this" context to DotChart
  // otherwise "this" would point to the Toggle instance
  handleToggle = (toggleVal) => {
    //reset currentColumn classmember variable
    this.currentColumn = this.toggleVals.find((tVal) => tVal.val === toggleVal).text
    // draw chart again to transition
    // animate polarization charts
    this.slides.forEach(slide => slide.draw(this.currentColumn))
  }

}

